import { render, staticRenderFns } from "./AsideMenuCloseButton.vue?vue&type=template&id=24d3e334"
import script from "./AsideMenuCloseButton.vue?vue&type=script&lang=ts"
export * from "./AsideMenuCloseButton.vue?vue&type=script&lang=ts"
import style0 from "./AsideMenuCloseButton.vue?vue&type=style&index=0&id=24d3e334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports